<template>
  <div>
    <vxe-grid
      ref="xTable"
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      row-key
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-warning">
            <span class="side-frame-text">货物信息</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="fromLoad('add')"
              :disabled="disabled"
              >添加货物
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-info"
              @click="choiceGoods()"
              :disabled="disabled"
              >选择货物
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="delSelectRow()"
              :disabled="disabled"
              >删除货物
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-link
            class="mr-2"
            type="primary"
            @click="fromLoad('edit', row)"
            :disabled="disabled"
            >编辑</el-link
          >
          <el-link type="danger" @click="delRow(row)" :disabled="disabled"
            >删除</el-link
          >
        </div>
      </template>
    </vxe-grid>
    <order-goods-edit
      ref="goodsEdit"
      :params="params"
      @addRowSave="newAddto"
      @editRowSave="editRowSave"
    />
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      v-el-dialog-drag
      :before-close="close"
      :close-on-click-modal="false"
      width="1000px"
    >
      <master-goods
        v-if="dialogOption.dialogVisible"
        :custCode="custCode"
        @close="close"
        @addTo="addTo"
      />
      <br />
    </el-dialog>
    <el-form ref="formData" :model="formData" class="mt-3" label-position="top">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item label="总件数" prop="totQty" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totQty"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="总收入重量kg" prop="totInWeight" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totInWeight"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="总收入体积m³" prop="totInVolume" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totInVolume"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="总支出重量kg" prop="totPayWeight" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totPayWeight"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="总支出体积m³" prop="totPayVolume" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totPayVolume"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="总货值" prop="totValue" size="small">
            <el-input
              style="width:100%"
              size="small"
              v-model="totValue"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { add } from '@/libs/util.number.js'
export default {
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    detailFormData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    OrderGoodsEdit: () => import('./order-goods-edit.vue'),
    MasterGoods: () => import('./table/master-goods.vue'),
  },
  data() {
    return {
      dialogOption: {
        title: '选择客户关联货物',
        dialogVisible: false,
      },
      params: {},
      formData: {},
      custCode: '',
      tableHeight: 360,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'left',
          width: 90,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          title: '货物名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '150',
          field: 'goodsName',
        },
        {
          title: '货物代码',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '100',
          field: 'goodsNo',
        },
        {
          title: '货物类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'goodsTypeName',
        },
        {
          title: '包装类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'packageTypeName',
        },
        {
          title: '包装件数',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'goodsQty',
        },
        {
          title: '预计重量kg',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'goodsWeight',
        },
        {
          title: '预计体积m³',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'goodsVolume',
        },
        {
          title: '货值',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'goodsValue',
        },
        {
          title: '实际重量kg',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'factWeight',
        },
        {
          title: '实际体积m³',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '95',
          field: 'factVolume',
        },
        {
          title: '备注说明',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          minWidth: '150',
          field: 'goodsRemarks',
        },
      ],
    }
  },
  watch: {
    matchData: {
      deep: true,
      handler() {
        this.$eventBus.$emit('resetContract')
      },
    },
  },
  computed: {
    isTabData() {
      return this.tableData && this.tableData.length
    },
    totQty() {
      return this.isTabData ? this.calcTotal('goodsQty') : this.detailFormData.totQty
    },
    totInWeight() {
      return this.isTabData ? this.calcTotal('goodsWeight') : this.detailFormData.totInWeight
    },
    totInVolume() {
      return this.isTabData ? this.calcTotal('goodsVolume') : this.detailFormData.totInVolume
    },
    totPayWeight() {
      return this.isTabData ? this.calcTotal('factWeight') : this.detailFormData.totPayWeight
    },
    totPayVolume() {
      return this.isTabData ? this.calcTotal('factVolume') : this.detailFormData.totPayVolume
    },
    totValue() {
      return this.isTabData ? this.calcTotal('goodsValue') : this.detailFormData.totValue
    },
    matchData() {
      return {
        totQty: this.totQty,
        totInWeight: this.totInWeight,
        totInVolume: this.totInVolume,
        totPayWeight: this.totPayWeight,
        totPayVolume: this.totPayVolume,
        totValue: this.totValue,
      }
    },
  },
  mounted() {
    let _this = this
    this.$eventBus.$on('splitCustCodeChange', function(val) {
      _this.load(val)
    })
  },
  methods: {
    load(val) {
      this.custCode = val
    },
    choiceGoods() {
      if (this.custCode == '') {
        this.$message.error('订单客户未选择，请检查')
      } else {
        this.dialogOption.dialogVisible = true
      }
    },
    reset() {
      this.formData = {}
      this.tableData = []
    },
    newAddto(data) {
      data = data instanceof Array ? data : [data]
      if (!this.tableData || !this.tableData.length) {
        this.tableData = data.map((t) => ({
          ...t,
        }))
      } else {
        const goodsNos = this.tableData.map((t) => t.goodsName)
        for (let a = data.length - 1; a >= 0; a--) {
          const index = goodsNos.indexOf(data[a].goodsName)
          if (index != -1) {
            let goodsQty = this.tableData[index].goodsQty || 0
            let newGoodsQty = data[a].goodsQty || 1
            let goodsValue = this.tableData[index].goodsValue || 0
            let newGoodsValue = data[a].goodsValue || 1
            let goodsWeight = this.tableData[index].goodsWeight || 0
            let newGoodsWeight = data[a].goodsWeight || 1

            let goodsVolume = this.tableData[index].goodsVolume || 0
            let newGoodsVolume = data[a].goodsVolume || 1
            this.tableData[index].goodsVolume = goodsVolume + newGoodsVolume

            let factWeight = this.tableData[index].factWeight || 0
            let newFactWeight = data[a].factWeight || 1
            this.tableData[index].factWeight = factWeight + newFactWeight

            let factVolume = this.tableData[index].factVolume || 0
            let newFactVolume = data[a].factVolume || 1
            this.tableData[index].factVolume = factVolume + newFactVolume

            this.tableData[index].goodsWeight = goodsWeight + newGoodsWeight
            this.tableData[index].goodsQty = goodsQty + newGoodsQty
            this.tableData[index].goodsValue = goodsValue + newGoodsValue
          } else {
            //data[a].goodsQty = 1
            this.addRowSave(data[a])
          }
        }
      }
      this.close()
    },
    addTo(data) {
      data = data instanceof Array ? data : [data]
      if (!this.tableData || !this.tableData.length) {
        this.tableData = data.map((t) => ({
          ...t,
          goodsQty: 1,
          goodsWeight: 0,
          goodsVolume: 0,
          goodsValue: 0,
          factWeight: 0,
          factVolume: 0,
        }))
      } else {
        const goodsNos = this.tableData.map((t) => t.goodsName)
        for (let a = data.length - 1; a >= 0; a--) {
          const index = goodsNos.indexOf(data[a].goodsName)
          if (index != -1) {
            let goodsQty = this.tableData[index].goodsQty || 0
            let newGoodsQty = data[a].goodsQty || 1
            this.tableData[index].goodsQty = goodsQty + newGoodsQty
            let goodsValue = this.tableData[index].goodsValue || 0
            let newGoodsValue = data[a].goodsValue || 1
            let goodsWeight = this.tableData[index].goodsWeight || 0
            let newGoodsWeight = data[a].goodsWeight || 1
            let goodsVolume = this.tableData[index].goodsVolume || 0
            let newGoodsVolume = data[a].goodsVolume || 1
            this.tableData[index].goodsVolume = goodsVolume + newGoodsVolume

            let factWeight = this.tableData[index].factWeight || 0
            let newFactWeight = data[a].factWeight || 1
            this.tableData[index].factWeight = factWeight + newFactWeight

            let factVolume = this.tableData[index].factVolume || 0
            let newFactVolume = data[a].factVolume || 1
            this.tableData[index].factVolume = factVolume + newFactVolume
            this.tableData[index].goodsWeight = goodsWeight + newGoodsWeight
            this.tableData[index].goodsValue = goodsValue + newGoodsValue
          } else {
            data[a].goodsQty = 1
            data[a].goodsWeight = 0
            data[a].goodsVolume = 0
            data[a].goodsValue = 0
            data[a].factWeight = 0
            data[a].factVolume = 0
            this.addRowSave(data[a])
          }
        }
      }
      this.close()
    },
    fromLoad(ref, row = {}) {
      if (ref === 'edit') {
        // 获取当前记录在记录集中的唯一索引
        let index = this.$refs.xTable.getRowIndex(row)
        this.$refs.goodsEdit.load(ref, { ...row, index: index })
        return
      }
      this.$refs.goodsEdit.load(ref, { ...row })
    },
    addRowSave(rowData) {
      this.tableData.push(rowData)
    },
    editRowSave(rowData) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (i === rowData.index) {
          this.$set(this.tableData, i, rowData)
        }
      }
    },
    delSelectRow() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords()
      if (selectRecords.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要删除的数据',
          type: 'warning',
        })
        return
      }
      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.xTable.removeCheckboxRow()
          selectRecords.forEach((item) => {
            let _XID = item._XID
            this.tableData.forEach((row, index) => {
              if (row._XID === _XID) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    delRow(row) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
          let index = this.$refs.xTable.getRowIndex(row)
          this.tableData.splice(index, 1)
        }
      })
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
    getGoodsData() {
      if (this.tableData.length < 1) {
        this.$message.error('订单货物信息未填写，请检查')
        return
      }
      this.formData.totQty = this.totQty
      this.formData.totInWeight = this.totInWeight
      this.formData.totInVolume = this.totInVolume
      this.formData.totPayWeight = this.totPayWeight
      this.formData.totPayVolume = this.totPayVolume
      this.formData.totValue = this.totValue
      this.formData.goodsList = this.tableData
      return this.formData
    },
    calcTotal(field) {
      if (!this.tableData || !this.tableData.length) return 0
      return parseFloat(
        this.tableData
          .map((item) => item[field] || 0)
          .reduce((res, next) => add(res, next))
      )
    },
  },
}
</script>
